import { useClient } from 'shared';

export interface CenterContact {
    first_name: string;
    phone_number: string;
    email: string;
}

const DEFAULT_EMAIL = 'team@join-tandem.com';
const DEFAULT_PHONE_NUMBER = '(614) 907-4374';

export function useCenterContact() {
    const { data, loading, error } = useClient<CenterContact>({ url: 'api/dashboard/center-contact/' });
    const contact = loading || error ? undefined : data;

    return {
        email: contact?.email ?? DEFAULT_EMAIL,
        phoneNumber:
            contact?.phone_number && contact.phone_number !== 'N/A' ? contact.phone_number : DEFAULT_PHONE_NUMBER,
    };
}
